export default "__VITE_ASSET__BjdURBYp__"